import { Colors, Icon, Text } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

import { IconCircle } from '../surfaces';

import { GLASS_SURFACE, SECTION_TITLE_TIGHT } from '@/components/objectives/objectiveStyles';

interface KeepInMindTileProps {
    /** The writer manages only their own objectives, so the guidance does not address a leader. */
    writesOwnObjectivesOnly: boolean;
}

/** The prototype's guidance tile, above the vision/alignment row and the rest of the form. */
export default function KeepInMindTile({ writesOwnObjectivesOnly }: KeepInMindTileProps) {
    const { t } = useTranslation();

    return (
        <div className={'w-full max-w-[628px]'}>
            <div
                className={`obj-header flex items-start gap-3 ${GLASS_SURFACE}`}
                data-testid={'objective-form-keep-in-mind'}
            >
                <IconCircle className={'bg-obj-tint h-[60px] w-[60px]'}>
                    <Icon
                        name={'lucide-lightbulb'}
                        size={36}
                        colorClassName={'text-obj-turquoise'}
                        strokeWidth={1.8}
                    />
                </IconCircle>

                <div className={'flex flex-1 flex-col gap-1.5'}>
                    <h2 className={SECTION_TITLE_TIGHT}>{t('objectives.form.keepInMind')}</h2>

                    <Text color={Colors.NAVY}>
                        {t(
                            writesOwnObjectivesOnly
                                ? 'objectives.form.keepInMindDescOwn'
                                : 'objectives.form.keepInMindDesc',
                        )}
                    </Text>
                </div>
            </div>
        </div>
    );
}
